import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

const hbPageWithAnalytics = (PageComponent) => {
  class PageWithAnalytics extends PureComponent {
    static fetchData = PageComponent.fetchData;
    static displayName = PageComponent.name + 'WithAnalytics';

    render() {
      return (
        <PageComponent
          {...this.props}/>
      )
    }
  }

  return connect(mapStateToProps)(PageWithAnalytics);
}

function mapStateToProps() {
  return {};
}

export default hbPageWithAnalytics;
